module.exports = __webpack_public_path__ + "media/assets/round-warning-24px-66e6e442.svg";